import { Injectable } from '@angular/core';
import { localStorageKeys } from '../common/constants/local.storage.keys';

export class LocalStorageService {
    public static setLocalStorageKeySubfix(key, hubName, userID?, shared?) {
        let subfix = userID ? `${key}_${hubName}_${userID}` : `${key}_${hubName}`;
        subfix = shared ? subfix + '_shared' : subfix;
        subfix += '_v2';
        return subfix;
    }

    public static getLocalStorageKeyForVisitorTrip(hubName, userFacebookID = '', isShared = false) {
        let key = LocalStorageService.setLocalStorageKeySubfix(
            localStorageKeys.visitorTrip,
            hubName,
            userFacebookID,
            isShared
        );
        return key;
    }

    public static getAllBackendSettingsFromLocalStorage() {
        const allSettingsStr = localStorage.getItem(localStorageKeys.allBackendSettings);
        if (!allSettingsStr) {
            console.error('No settings found');
            return null;
        }

        const allSettings = JSON.parse(allSettingsStr);
        return allSettings;
    }

    public static getCustomDefaultPlaceCategoryFromLocalStorage() {
        const allSettings = this.getAllBackendSettingsFromLocalStorage();

        if (!allSettings.customSettings.customDefaultPlaceCategory) {
            console.error('No custom default place categories found');
            return null;
        }

        return {
            ...allSettings.customSettings.customDefaultPlaceCategory,
            mergedDefaultCategories: allSettings.mergedDefaultCategories,
            businessType: allSettings.customSettings.dataSource.businessType,
            toggle: allSettings.toggle,
            blockGooglePlaceCategories: allSettings.blockGooglePlaceCategories,
        };
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/services/localStorageService.ts